let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class CategoriesInputFilterController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }
  
}

CategoriesInputFilterController.$inject = inject;

export default CategoriesInputFilterController;




/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-input-filter/categories-input-filter.controller.js
 **/